/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Integration } from '../../models/integration';
import { UpdateParentIntegrationRequest } from '../../models/update-parent-integration-request';

export interface Update_3$Params {
  organizationId: string;
  
    /**
     * Parent Integration to be updated.
     */
    body: UpdateParentIntegrationRequest
}

export function update_3(http: HttpClient, rootUrl: string, params: Update_3$Params, context?: HttpContext): Observable<StrictHttpResponse<Integration>> {
  const rb = new RequestBuilder(rootUrl, update_3.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Integration>;
    })
  );
}

update_3.PATH = '/v1/organizations/{organizationId}/parent/integration';
